(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polaroid-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict'; 

  /* ── Init one carousel ──────────────────────────────────── */
  function initCarousel(section) {
    if (section._polaroidInit) return;
    section._polaroidInit = true;

    var swiperEl      = section.querySelector('.polaroid-swiper');
    var paginationEl  = section.querySelector('.polaroid-pagination');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      centeredSlides: false,
      watchSlidesProgress: true,
      pagination: {
        el: paginationEl,
        clickable: true,
        renderBullet: function (index, className) {
          return '<button class="' + className + '" aria-label="Slide ' + (index + 1) + '"></button>';
        }
      },
      on: {
        slideChange: function () {
          section.querySelectorAll('.polaroid-card__video').forEach(function (v) {
            v.pause();
            var m = v.closest('.polaroid-card__media');
            if (m) m.classList.remove('is-playing');
          });
        }
      },
      breakpoints: {
        750:  { spaceBetween: 20 },
        990:  { spaceBetween: 24 },
        1200: { spaceBetween: 28 }
      }
    });

    /* ── Video play / pause ─────────────────────────────── */
    section.querySelectorAll('.polaroid-card').forEach(function (card) {
      var btn   = card.querySelector('[data-play-btn]');
      var video = card.querySelector('.polaroid-card__video');
      var media = card.querySelector('.polaroid-card__media');
      if (!btn || !video) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) {
          section.querySelectorAll('.polaroid-card__video').forEach(function (v) {
            if (v !== video) {
              v.pause();
              var m = v.closest('.polaroid-card__media');
              if (m) m.classList.remove('is-playing');
            }
          });
          video.play();
          media.classList.add('is-playing');
        } else {
          video.pause();
          media.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', function () {
        media.classList.remove('is-playing');
      });
    });
  }

  /* ── Boot ───────────────────────────────────────────────── */
  function bootAll() {
    loadSwiper(function () {
      document.querySelectorAll('[data-polaroid-section]').forEach(initCarousel);
    });
  }

  document.addEventListener('DOMContentLoaded', bootAll);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-polaroid-section]');
    if (!section) return;
    section._polaroidInit = false;
    loadSwiper(function () { initCarousel(section); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
